import React from 'react';
class CustomFormSF extends React.Component {
    constructor(props) {
        super(props);
        this.state = { value: '' };
        this.handleChange = this.handleChange.bind(this);
    }

    handleChange(event) {
        this.setState({ value: event.target.value });
    }

    submitForm() {
        this.refs.email.value &&
            this.refs.email.value.indexOf('@') > -1 &&
            this.props.onValidated({
                EMAIL: this.refs.email.value,
            });
    }

    render() {
        /* eslint-disable */
        const { status, message, onValidated } = this.props;
        let email, name;
        /* eslint-enable */

        return (
            <div>
                {status === 'sending' && (
                    <div className="mc-message" style={{ color: 'blue' }}>
                        sending...
                    </div>
                )}
                {status === 'error' && (
                    <div
                        className="mc-message"
                        style={{ color: '#257EFF' }}
                        dangerouslySetInnerHTML={{ __html: message }}
                    />
                )}
                {status === 'success' && (
                    <div
                        className="mc-message"
                        style={{ color: '#257EFF' }}
                        dangerouslySetInnerHTML={{ __html: message }}
                    />
                )}
                <div
                    style={{
                        background: '#fff',
                        borderRadius: 2,
                        padding: 10,
                        display: 'inline-block',
                    }}>
                    <div
                        className={`mc-placeholder ${
                            this.state.value === '' ? 'active' : 'not-active'
                        }`}>
                        <span className="label">
                            Newsletter
                            <br />
                            Enter your e-mail address
                        </span>
                    </div>
                    {/* eslint-disable */}
                    <input
                        style={{ fontSize: '2em', padding: 5 }}
                        ref={(node) => (email = node)}
                        ref="email"
                        type="email"
                        placeholder=""
                        value={this.state.value}
                        onChange={this.handleChange}
                    />
                    {/* eslint-enable */}
                    <button
                        className={`submit-btn ${
                            this.state.value === '' ? 'not-active' : 'active'
                        }`}
                        style={{ fontSize: '2em', padding: 5 }}
                        onClick={this.submitForm.bind(this)}
                    />
                </div>
            </div>
        );
    }
}

export default CustomFormSF;



// WEBPACK FOOTER //
// ./src/components/Pages/CustomFormSF.jsx